import _ from 'lodash';
import Immutable from 'immutable';
import Cookies from 'js-cookie';

import ActionTypes from '../constants/ActionTypes';

let userLog = Cookies.getJSON('userlog');

if (typeof userLog === 'undefined') {
    userLog = {};
}

const initialState = _.clone(userLog);

function updateUserLog(state, payload, clear) {
    const key = payload.sceneKey;
    let value;
    const step = {
        intensity: payload.intensity,
        instability: payload.instability,
        timestamp: new Date().getTime(),
    };
    if (clear) {
        value = [step];
    } else {
        value = state.get(key, []).concat();
        value.push(step);
    }

    const newUserLog = state.toJS();
    newUserLog[key] = value;
    // Cookies.set('userlog', newUserLog, value);
    Cookies.set('userlog', {});
    return state.set(key, value);
}

module.exports = (oldState, action) => {
    let state = oldState;
    if (typeof oldState === 'undefined') {
        state = Immutable.Map(initialState);
    }

    switch (action.type) {
    case ActionTypes.USER_LOG_ADD:
        return updateUserLog(state, action.payload, false);
    case ActionTypes.USER_LOG_CLEAR:
        return updateUserLog(state, action.payload, true);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./js/stores/UserLogStore.js